import { apiHelper } from './api';

export const notificationService = {
  // Get all notifications
  getNotifications: async () => {
    const response = await apiHelper.get('/notifications');
    return response.data;
  },

  // Get unread notifications
  getUnreadNotifications: async () => {
    const response = await apiHelper.get('/notifications/unread');
    return response.data;
  },

  // Get notification statistics
  getNotificationStats: async () => {
    const response = await apiHelper.get('/notifications/stats');
    return response.data;
  },

  // Get single notification
  getNotification: async (notificationId) => {
    const response = await apiHelper.get(`/notifications/${notificationId}`);
    return response.data;
  },

  // Create notification
  createNotification: async (notificationData) => {
    const response = await apiHelper.post('/notifications', notificationData);
    return response.data;
  },

  // Create bulk notifications (Admin only)
  createBulkNotifications: async (notificationData) => {
    const response = await apiHelper.post('/notifications/bulk', notificationData);
    return response.data;
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    const response = await apiHelper.patch(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    const response = await apiHelper.patch('/notifications/mark-all-read');
    return response.data;
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    const response = await apiHelper.delete(`/notifications/${notificationId}`);
    return response.data;
  }
};